import React from 'react'

export default ({width, height}) => (
  <svg className="shape shape--bookmark-plain" width={width} height={height} viewBox="0 0 24 24">
    <path d='M12.81,6.62 L10.3907185,0.920482635 C10.1749306,0.412114113 9.82422192,0.414736193 9.60928154,0.921873093 L7.19,6.63 L0.999738693,7.15518211 C0.447598259,7.20202574 0.341547453,7.53588268 0.759189606,7.89768623 L5.46,11.97 L4.04803497,18.0225086 C3.92209474,18.5623622 4.20658668,18.7666718 4.67930252,18.4813595 L10,15.27 L15.3206975,18.4813595 C15.7952772,18.7677967 16.0780362,18.560242 15.9533555,18.0225086 L14.55,11.97 L19.2422009,7.89768623 C19.6607218,7.53445616 19.5502333,7.20121622 19.0002613,7.15379166 L12.81,6.62 Z'></path>
  </svg>
)


// WEBPACK FOOTER //
// ./src/components/Shapes/BookmarkPlain.js